import { defineComponent as _defineComponent } from 'vue'
import { getInstance } from '@/auth'
import { computed } from 'vue'
import { useGetters } from 'vuex-composition-helpers'
import JobAssignmentFormRequirement from '@/models/job-assignment-form-requirement'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsText from '@/components/vision/VsText.vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsHeading from '@/components/vision/VsHeading.vue'

interface Props {
  formRequirements: JobAssignmentFormRequirement[]
  serviceProviderBusinessUnitId?: string | null
  hubId: string
  isNewJob?: boolean
  readonly?: boolean
}

interface AssignmentFormRequirementViewModel {
  id: string
  formName: string
  occurence: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AssignmentFormRequirements',
  props: {
    formRequirements: null,
    serviceProviderBusinessUnitId: { default: null },
    hubId: null,
    isNewJob: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false }
  },
  emits: ["update-form-requirements", "show-assignment-form-selection", "fill-form-requirement", "view-form-requirement-submission"],
  setup(__props: any, { emit }: { emit: ({
  (
    e: 'update-form-requirements',
    requirements: JobAssignmentFormRequirement[]
  ): void
  (e: 'show-assignment-form-selection'): void
  (e: 'fill-form-requirement', requirement: JobAssignmentFormRequirement): void
  (
    e: 'view-form-requirement-submission',
    requirement: JobAssignmentFormRequirement
  ): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { formRequirements: JobAssignmentFormRequirement[], serviceProviderBusinessUnitId: string | null, hubId: string, isNewJob: boolean, readonly: boolean }





const auth = getInstance()

const { assignmentFormRequirements: featureFlag } = useGetters('featureFlags', [
  'assignmentFormRequirements',
])
const { getById: getFormById } = useGetters('forms', ['getById'])
const { getBusinessUnitById } = useGetters('businessUnits', [
  'getBusinessUnitById',
])

const shouldShowFormRequirements = computed(() => {
  if (!featureFlag.value) return false
  if (props.serviceProviderBusinessUnitId === null) return false

  const userBusinessUnitId = auth.organizationId
  const hub = getBusinessUnitById.value(props.hubId)

  const userIsInServiceProvider =
    props.serviceProviderBusinessUnitId === userBusinessUnitId
  const isAssignedToHubAndUserIsInHub =
    !!hub?.ownerId &&
    props.serviceProviderBusinessUnitId === props.hubId &&
    hub.ownerId === userBusinessUnitId
  return userIsInServiceProvider || isAssignedToHubAndUserIsInHub
})

const canFillForms = computed(() => {
  return !props.isNewJob
})

const formRequirementNames = computed(() => {
  const mappedRequirements: Array<AssignmentFormRequirementViewModel> = []
  props.formRequirements.forEach((requirement) => {
    const form = getFormById.value(requirement.formId)
    const formName = form?.name ?? 'Unknown form'
    let occurence = 1
    for (let index = mappedRequirements.length - 1; index >= 0; index--) {
      if (mappedRequirements[index].formName === formName) {
        occurence = mappedRequirements[index].occurence + 1
        break
      }
    }

    mappedRequirements.push({
      id: requirement.id,
      formName,
      occurence,
    })
  })

  return mappedRequirements
})

function openFormSelectionBottomSheet() {
  emit('show-assignment-form-selection')
}

function removeFormRequirement(id: string) {
  const formRequirements = [...props.formRequirements]
  const newFormRequirements = formRequirements.filter(
    (requirement) => requirement.id !== id
  )

  emit('update-form-requirements', newFormRequirements)
}

function getFormName(requirementId: string): string {
  const model = formRequirementNames.value.find(
    (requirement) => requirement.id === requirementId
  )
  if (!model) return ''
  return model.occurence > 1
    ? `${model.formName} (${model.occurence})`
    : model.formName
}

function fillFormRequirement(requirement: JobAssignmentFormRequirement) {
  emit('fill-form-requirement', requirement)
}

function viewFormRequirementSubmission(
  requirement: JobAssignmentFormRequirement
) {
  emit('view-form-requirement-submission', requirement)
}

function getFormIcon(requirement: JobAssignmentFormRequirement) {
  return requirement.formSubmissionId === null
    ? 'mdi-clipboard-text-outline'
    : 'mdi-clipboard-check-outline'
}

function getFormIconColor(requirement: JobAssignmentFormRequirement) {
  return requirement.formSubmissionId !== null ? 'green' : null
}

function canFillForm(requirement: JobAssignmentFormRequirement) {
  if (!canFillForms.value) return false
  if (requirement.formSubmissionId !== null) return false

  return !requirement.isDraft()
}

function canViewFormSubmission(requirement: JobAssignmentFormRequirement) {
  if (!canFillForms.value) return false
  return requirement.formSubmissionId !== null
}

return { __sfc: true,props, emit, auth, featureFlag, getFormById, getBusinessUnitById, shouldShowFormRequirements, canFillForms, formRequirementNames, openFormSelectionBottomSheet, removeFormRequirement, getFormName, fillFormRequirement, viewFormRequirementSubmission, getFormIcon, getFormIconColor, canFillForm, canViewFormSubmission, VsWrapper, VsText, VsButton, VsHeading }
}

})